module.exports = __webpack_public_path__ + "static/img/what_need2.69978d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/what_need2.png
// module id = o1P1
// module chunks = 0